import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import { styles } from "../styles/styles";
import FeedIcons from "../../../assets/Icons/FeedIcons";

export default function NextProfileButton({
  handleNextProfile,
}: {
  handleNextProfile: any;
}) {
  return (
    <TouchableOpacity onPress={handleNextProfile} style={styles.CrossIcon}>
      <FeedIcons.CrossIcon />
    </TouchableOpacity>
  );
}
